import * as _ from "lodash";

/**
 * Do some basic calculations on the Ask Ida results
 * @param {number} before
 * @param {number} after
 * @param {number} expected
 * @return {{benchmarkValue: number, ratioChange: number, hasIncreased: boolean, values: {before: number, after: number, expected: number}}}
 */
export const useAskIdaResults = (
  before: number,
  after: number,
  expected?: number
): {
  benchmarkValue: number;
  ratioChange: number;
  hasIncreased: boolean;
  values: { before: number; after: number; expected: number };
} => {
  /**
   * Internalise values by converting them to number (undefined = 0)
   */
  const [iBefore, iExpected, iAfter] = _.map([before, expected, after], _.unary(Number));

  /**
   * Pick the largest value and consider that as 100%
   * @type {number}
   */
  const benchmarkValue = _.max([iBefore, iExpected, iAfter]) as number;

  /**
   * Tell if we can see an increase compared to the expectation
   * @type {boolean}
   */
  const hasIncreased = iAfter > (expected ? iExpected : iBefore);

  /**
   * Find how much the difference is between the expected and the observed value
   * @type {number}
   */
  const ratioChange = Math.abs((expected ? iExpected : iAfter) / (expected ? iAfter : iBefore) - 1) * 100;

  return {
    benchmarkValue,
    ratioChange,
    hasIncreased,
    values: { before: iBefore, after: iAfter, expected: iExpected }
  };
};
